import React from 'react';
import Modal from '../common/Modal.mjs';

export default function AboutModal({ isOpen, onClose }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="About Us">
            <div className="about-content">
                <h3 className="text-xl font-semibold mb-4">Our Mission</h3>
                <p className="mb-4">
                    At Nexus of Truth, we believe in the power of accurate information. Our mission
                    is to provide a platform where truth is valued above all else, helping readers
                    navigate the complex world of information with confidence.
                </p>

                <h3 className="text-xl font-semibold mb-4">Our Story</h3>
                <p className="mb-4">
                    Founded in 2023, Nexus of Truth emerged from a growing need for reliable sources
                    of information in an era of misinformation. Our team of dedicated journalists,
                    researchers, and fact-checkers work tirelessly to ensure that every article
                    published meets our rigorous standards for accuracy and integrity.
                </p>

                <h3 className="text-xl font-semibold mb-4">Our Values</h3>
                <ul className="list-disc pl-5 mb-4 space-y-2">
                    <li>
                        <strong>Accuracy:</strong> We verify all information before publication.
                    </li>
                    <li>
                        <strong>Transparency:</strong> We clearly disclose our sources and methods.
                    </li>
                    <li>
                        <strong>Independence:</strong> We maintain editorial independence from
                        external influences.
                    </li>
                    <li>
                        <strong>Fairness:</strong> We present multiple perspectives on complex
                        issues.
                    </li>
                    <li>
                        <strong>Accountability:</strong> We promptly correct errors when they occur.
                    </li>
                </ul>
            </div>
        </Modal>
    );
}
